import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsHingesOptions = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.hinges.options;

export const options = setCalculationModeAdminSettingsHingesOptions(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_HINGES_OPTIONS',
  []
);
